import styled from 'styled-components'

import smallCaps from '../../styles/mixins/smallCaps'

export default styled.p`
  ${smallCaps}
  color: ${p => p.theme.colors.primaryColor};
  margin-bottom: 0;
`
